import React from 'react';

const LoadingDeleteComponent = () => {
    return (
        <div className="flex justify-center items-center">
            <div className="loader-delete"></div>
        </div>
    );
};

export default LoadingDeleteComponent;